/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrient_ProteinInputs */

const en_nutrient_protein = /** @type {(inputs: Nutrient_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein`)
};

const de_nutrient_protein = /** @type {(inputs: Nutrient_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiweiß`)
};

/**
* | output |
* | --- |
* | "Protein" |
*
* @param {Nutrient_ProteinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrient_protein = /** @type {((inputs?: Nutrient_ProteinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrient_ProteinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrient_protein(inputs)
	return en_nutrient_protein(inputs)
});